export default __webpack_public_path__ + "static/media/Amalfi.7053d5d2.ttf";